export default __webpack_public_path__ + "static/media/rapidcity.df79181a.jpg";